import React from 'react';
import { SnakSlide } from '../../experience/SnakSlide';
import { storyboard } from '../../../data/storyboard';
const PER_ROW = 5;

/** Landscape print layout of the storyboard. */
export function StoryboardPdf() {
  const rows = Array.from({
    length: Math.ceil(storyboard.length / PER_ROW)
  }, (_, i) => storyboard.slice(i * PER_ROW, i * PER_ROW + PER_ROW));
  return <div className="px-12" data-id="element-655" data-mp="2uug73w3ah1dm">
      <header data-pdf-block className="pb-8" data-id="element-656" data-mp="2uu6cfv7au61l">
        <span className="font-body text-[10px] uppercase tracking-[0.24em] text-[rgba(1,51,43,0.45)]" data-id="element-657" data-mp="2usd50dov3hsj">
          Meet the Filteks
        </span>
        <h1 className="mt-2 font-heading text-[40px] leading-none tracking-[-0.03em] text-background" data-id="element-658" data-mp="2kws7arqtt3ol">
          Storyboard
        </h1>
      </header>

      {rows.map((row, r) => <div key={r} data-pdf-block className="grid grid-cols-5 gap-5 pb-10" data-id="element-659" data-mp="2bvu58ezy768n" data-mpi={r}>
          {row.map(slide => {
        const n = storyboard.indexOf(slide) + 1;
        return <div key={slide.step} data-id="element-660" data-mp="ce1ta9s3jz1e">
                <div className="inline-block rounded-[30px] bg-[#0B1512] p-[6px]" data-id="element-661" data-mp="cd0hu4765aj5">
                  <SnakSlide step={slide.step} width={172} label={slide.title} data-id="element-662" data-mp="8czshoij7exb" />
                </div>
                <span className="mt-4 block font-body text-[9px] uppercase tracking-[0.22em] text-[rgba(1,51,43,0.4)]" data-id="element-663" data-mp="mchl6eyy7cby">
                  Slide {String(n).padStart(2, '0')}
                </span>
                <h2 className="mt-1.5 font-heading text-[15px] leading-[1.15] text-background" data-id="element-664" data-mp="3psexoukl0wdg">
                  {slide.title}
                </h2>
                <p className="mt-1.5 font-body text-[10.5px] leading-[1.55] text-[rgba(1,51,43,0.65)]" data-id="element-665" data-mp="3kvoh864v7yri">
                  {slide.note}
                </p>
              </div>;
      })}
        </div>)}
    </div>;
}